import { React, useState,useEffect } from "react";
import "./landing.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from  "./img/switch.png";
import logoutimg from "./img/logout.png";
import remove from  "./img/remove.png";
import {CREATE_EXTERNAL_ACCESS} from '../AppConstant'
import validator from "validator";
function Landing() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [contact, setContact] = useState("");
    const [pan, setPan] = useState("");
    const [bod, setBod] = useState("");
    const [doj, setDoj] = useState("");
    const [requestorname,setRequestorname]= useState("");
    const [requestdept,setRequestdept]= useState("");
    const [purpose,setPurpose]= useState("");
    const [asset_id,setAsset_id]= useState("");
    const [selectedrpmanager,setSelectedrpmanager] = useState("");
    const [ifchecked,setIfchecked] = useState(false);
    const [selectedtext,setSelectedtext] = useState("");
    const [start,setStart] = useState(""); 
    const [end,setEnd] = useState(""); 
    const [mindateset,setMindateset] = useState("")
    const [emailiddataset,setEmailiddataset]=useState([{email: "",errordata:""}]);
    // const [emailerror, setEmailerror] = useState([]);
    
   
    const calltosetmindate=()=>{
        setSelectedrpmanager(localStorage.getItem('functionheademail'))
        let month;
        let day;
        if((new Date().getMonth()+1)<9){
            month="0"+(new Date().getMonth()+1)
        }else{
            month= (new Date().getMonth()+1)
        }
        if( new Date().getDate()<9){
            day= "0"+new Date().getDate()
        }else{
            day= new Date().getDate()
        }
        let date = new Date().getFullYear()+'-'+month+'-'+day
       setMindateset(date)
    }
    useEffect(()=>{calltosetmindate()},[])
    const handleSubmit = (e) => {
        e.preventDefault();
        if(!purpose||!emailiddataset[0].email||!selectedrpmanager){
            alert("Please fill all the fields")
        }else{
            getUserData();
            
        }
        
        // Add your form submission logic here
        
    };

    const redirectToLogin = ()=>{
        window.location.href = "/login"
    }
    
     const handleReset = () => {
        // Reset all state variables here
        setRequestdept("");
        setRequestorname("");
        setPurpose("");
        setAsset_id("");
        setSelectedrpmanager("")
        setIfchecked(false)
        const Checkboxes = document.getElementById('checkboxs');
        if(Checkboxes.checked===true){
            Checkboxes.checked=false
        }
        
    };
    const getUserData = ()=>{
       
        // let empid= requestorname
        // let rqdept= requestdept
        let empid=  localStorage.getItem('empid');
        let rqdept= localStorage.getItem('dept');
        let reason= purpose
        let emailidlist= emailiddataset
        let fhemailid= localStorage.getItem('functionheademail')
        let empemailid = localStorage.getItem('emailid');
        let empname = localStorage.getItem('empname');
        let fhname = localStorage.getItem('functionheadname');
        let remarks="submitted"
        
        axios.post(CREATE_EXTERNAL_ACCESS, {empid,rqdept,reason,emailidlist,fhemailid,empemailid,fhname,empname,remarks}).then(function (response) {
          //console.log("SuccessFully updated");
          alert(response.data);
          handleReset();
          

        })
          .catch(function (error) {
            console.log(error);
          });
       
    }
    const redirectTodashboard = ()=>{
        window.location.href = "/landingPage"
    }

    const checkedval=(e)=>{
        if(e.currentTarget.checked===true){
            setIfchecked(true)
        }else{
            setIfchecked(false)
        }
       
    }
    const callselectedfn=(e)=>{
        setSelectedrpmanager(e.target.value)
        setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
    }
    const callinputsetfn=(e)=>{
        if(e.target.value.length>6){
            alert("Employee ID cannot exceed 6 digit")           
        }else{
            setRequestorname(e.target.value)
        }   
        
    }
    const isAlpha = checkvalue => /^[a-zA-Z]*$/.test(checkvalue)
    const assetentryfn=(e)=>{
        let checkvalue =e.target.value
        if(e.target.value.length===12){
            let strRegex = new RegExp(/^[A-Za-z]+$/i);
            let result1 = strRegex.test(checkvalue);
            let strRegex2 = new RegExp(/^[0-9]+$/i);
            let result2 = strRegex2.test(checkvalue);
            if(result1 || result2===true){
                alert("Should contain alphanumeric")
            }
           
        }
        setAsset_id(e.target.value)
    }

    const createnewfield=()=>{
        setEmailiddataset([...emailiddataset,{email: ""}])
      }
  
      const handleChange = (i, e) => {
        let emailid=e.target.value
        let newFormValues = [...emailiddataset];
        if (validator.isEmail(emailid)) {           
            newFormValues[i].errordata = "";
           
        } else {
            newFormValues[i].errordata= "Enter valid Email!";
            
        }
       
        newFormValues[i][e.target.name] = emailid;
        setEmailiddataset(newFormValues);
      }
      const removeFormFields = (i) => {
        let newFormValues = [...emailiddataset];
        newFormValues.splice(i, 1);
        setEmailiddataset(newFormValues)
    }
    
    return (
        <form action="#" method="get">
                <div className="row">
                    {/* <div className="col-md-6">
                    <label for="firstname">
                    Emp ID
                    </label>
                    <input
                        type="number"
                        name="firstname"
                        id="firstname"
                        value={requestorname}
                        onChange={(e) =>
                            callinputsetfn(e)
                        }
                        maxlength="6"
                        placeholder="Emp ID"
                        required
                    />
                    </div> */}
                    {/* <div className="col-md-6">
                    <label for="lastname">Requestor department</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={requestdept}
                        onChange={(e) =>
                            setRequestdept(e.target.value)
                        }
                        placeholder="Department"
                        required
                        maxlength="30"
                    />
                    </div> */}
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                    <label for="firstname">
                    Purpose to provide Data sharing access
                    </label>
                    <input
                        type="text"
                        name="firstname"
                        id="firstname"
                        value={purpose}
                        onChange={(e) =>
                            setPurpose(e.target.value)
                        }
                        placeholder="Purpose to provide access"
                        required
                    />
                    </div>
                    {/* <div className="col-md-6"> <label for="lastname">Start Date</label>
                    <input type="date"  min={mindateset} onChange={(e) =>setStart(e.target.value)} id="birthday" name="birthday"/>
                    </div>
                    <div className="col-md-6">
                    <label for="lastname">End Date</label>
                    <input type="date"   min={mindateset} onChange={(e) =>setEnd(e.target.value)} id="birthday" name="birthday"/>
                    </div>
                    */}
                    <div className="col-md-12">
                    <label for="email">Email ID</label>
                    {emailiddataset.map((e, index) => (
                        <div className="row">
                    <div className="col-md-10 mt-2">        
                    <input
                        type="text"
                        name="email"
                        id="email"
                        value={e.partno} onChange={e => handleChange(index, e)}
                        
                        placeholder="Email ID to share data"
                        required
                         maxlength="200"
                        
                    />
                    <span
                    style={{
                        fontWeight: "bold",
                        color: "red"
                    }}
                >
                    {e.errordata}
                </span>
                    </div>
                    <div className="col-md-2">
                     { index ? <img className="removefn" src={remove} onClick={()=>removeFormFields(index)}/>:''}
                    </div>
                    </div>
                    
                ))}
                
                 <p className="add-designs-sharepoint" onClick={createnewfield}> ADD</p> 
                    </div> 
                    <div className="col-md-12">
                    <label> Functional Head</label>
                    <select
                        name="select"
                        id="select"
                        value={selectedrpmanager}
                        onChange={(e) =>callselectedfn(e)}
                    >
                        <option
                                            value=""
                                            disabled
                                            selected={selectedrpmanager === ""}
                                        >
                                            Functional Head
                                        </option>
                                         <option disabled value={localStorage.getItem('functionheademail')}>{localStorage.getItem('functionheadname')}</option>
                                         

 
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                    </div>
					<div className="text-design-note">Note: Please provide a detailed justification for the access request.</div>
                    <div className="row">
                    <div className="col-md-6">
                    <Button
                        variant="primary"
                        className="btns"
                        type="reset"
                        value="reset"
                        onClick={() => handleReset()}
                    >
                        Clear
                    </Button>
                    </div>
                    <div className="col-md-6">
                    <Button
                    variant="primary"
                      className="btns"
                        type="submit"
                        value="Submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Submit
                    </Button>
                    </div>
                    </div>
                </form>
        // <div className="bg_set_usb">   
        //  <div className="switch" >
        //             <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
        //             <img className="switch-img" src={image}/>
        //             <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
        //         </div><br/><br/>         
        //      <div>
        //     </div>
        //     <div>
        // <div className="Apps ">
        //     <p className="Headings">VPN Requisition</p>
        //     <fieldset>
                
        //     </fieldset>
        // </div> 
        //     </div>
        
        // </div>
    );
}


export default Landing;
